module.exports = __webpack_public_path__ + "static/assets/ec10b0c28e5e7665e983309f8278f91d.svg";